"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeCycle = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.LifeCycle = (browser_core_1.AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map